export enum LocationVerificationPillVisual {
    VERIFYING = 'verifying',
    SUCCESS = 'success',
    FAILED = 'failed'
}

export enum GeoLogRumTypes {
    PROGRESS = 'progress',
    PASSED = 'passed',
    REJECTED = 'rejected',
    FAILED = 'failed',
    INVALIDATED = 'invalidated',
    INIT = 'init',
    CALLBACK_SET = 'callbackSet',
    CONFIG_SET = 'configSet',
    PERMISSION_GRANTED = 'permissionGranted',
    PERMISSION_DENIED = 'permissionDenied',
    PERMISSION_REVOKED = 'permissionRevoked',
    PERMISSION_PRECHECK = 'permissionPrecheck',
    PERMISSION_PRECHECK_FAILED = 'permissionPrecheckFailed',
    LOCAL_NETWORK_PERMISSION_PRECHECK = 'localNetworkPermissionPrecheck',
    LOCAL_NETWORK_PERMISSION_GRANTED = 'localNetworkPermissionGranted',
    LOCAL_NETWORK_PERMISSION_DENIED = 'localNetworkPermissionDenied',
    LOCAL_NETWORK_PERMISSION_FAILED = 'localNetworkPermissionFailed'
}
